<template>
    <main class="wrapper">
        <page-head>
            <el-form class="search-form" slot="left" label-width="85px">
                <x-form
                    label="书友ID"
                    v-model="searchModel.uid"
                    placeholder="输入书友ID"
                ></x-form>
                <x-form
                    label="审核状态"
                    type="select"
                    :options="stateList"
                    v-model="searchModel.auditStatus"
                ></x-form>
                <el-button type="primary" @click="search">查询</el-button>
            </el-form>
        </page-head>

        <x-table
            :tableData="tableData"
            :tableHeaders="tableHeaders"
            :pageModel="pageModel"
            border
            :total="total"
            :clickData="clickData"
            @clickRight="clickRight"
            :fetchList="fetchList"
            select="true"
            position="left"
            @selectionChange="handleSelectionChange"
        ></x-table>

        <el-dialog title="审核提示" :visible.sync="dialogVisible" width="40%">
            <el-form>
                <el-form-item label="">
                    <el-radio-group v-model="auditStatus">
                        <el-radio :label="2">审核通过</el-radio>
                        <el-radio :label="3">审核不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="不通过原因"
                    label-width="100px"
                    v-if="auditStatus == 3"
                >
                    <el-input v-model="auditDesc" type="textarea"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="audit">确认</el-button>
            </div>
        </el-dialog>
    </main>
</template>

<script type="text/javascript">
import { applyList, auditApply } from "@/api/group";

import { formatDate } from "@/utils/util";

export default {
    data() {
        return {
            searchModel: {
                uid: "",
                auditStatus: 1, //1.审批中 2.审批通过 3.审批驳回
            },
            stateList: [
                {
                    label: "待审核",
                    value: 1,
                },
                {
                    label: "审批通过",
                    value: 2,
                },
                {
                    label: "审批驳回",
                    value: 3,
                },
            ],
            tableData: [],
            tableHeaders: [
                {
                    headerKey: "uid",
                    headerName: "书友ID",
                },
                {
                    headerKey: "applyTime",
                    headerName: "申请时间",
                },
                {
                    headerKey: "registerDays",
                    headerName: "注册天数",
                },
                {
                    headerKey: "signInDays",
                    headerName: "打卡天数",
                },
                {
                    headerKey: "signInCount",
                    headerName: "打卡次数",
                },
                {
                    headerKey: "auditStatus",
                    headerName: "审核状态",
                    maps: {
                        1: "待审核",
                        2: "审批通过",
                        3: "审批驳回",
                    },
                },
                {
                    headerKey: "auditDesc",
                    headerName: "不通过原因",
                },
            ],
            pageModel: {
                page: 1,
                size: 10,
            },
            total: 0,
            clickData: [
                {
                    label: "审核",
                    value: "audit",
                    rule(row) {
						return row.auditStatus === 1;
					}
                },
            ],
            dialogVisible: false,
            auditDesc: "",
            auditStatus: 2,
        };
    },
    components: {},
    methods: {
        search() {
            this.pageModel.page = 1;
            this.fetchList();
        },
        fetchList() {
            applyList({
                ...this.pageModel,
                uid: this.searchModel.uid ? Number(this.searchModel.uid) : 0,
                auditStatus: this.searchModel.auditStatus
                    ? this.searchModel.auditStatus
                    : 0,
            }).then((res) => {
                const { applicants, total } = res.data;
                this.tableData = applicants;
                this.total = total;
            });
        },
        clickRight({ row, type }) {
            this.dialogVisible = true;
            this.selectId = [row.uid];
        },
        audit() {
            if (this.auditStatus == 3 && !this.auditDesc) {
                this.$message.error("请填写不通过原因！");
            }
            auditApply({
                auditStatus: this.auditStatus,
                auditDesc: this.auditDesc,
                userIds: this.selectId.join(","),
            }).then((res) => {
                this.$message.success("操作成功");
                this.selectId = [];
                this.dialogVisible = false;
                this.auditDesc = "";
                this.fetchList();
            });
        },
        handleSelectionChange(val) {
            this.selectId = [];
            if (val.length) {
                val.forEach((item) => {
                    this.selectId.push(item.uid);
                });
            }
        },
    },
    mounted() {
        this.fetchList();
    },
};
</script>

<style lang="less"></style>
